/* eslint-disable indent */
import styled, { css } from 'styled-components';
import {
  Modal,
  Space,
  Checkbox,
  Dropdown,
  Button,
  TableRow,
} from '@cashfree-intl/coherent';

export const StyledModal = styled(Modal)`
.modal-content {
    padding: $pix-32;
    padding-top: $pix-24;
  }

  .modal-content-row {
    display: flex;
  }

  .label {
    color: #847f8d;
  }

  .cta-wrapper {
    text-align: right;
  }

  .ui.dropdown.vendor-recon-report-type-dropdown {
    margin-bottom: $pix-24;
    .menu.transition.visible {
      max-width: unset;
      width: 20rem;
    }
  }

  .select-field {
    width: 20rem;

    .ui.dropdown {
      &.file-format {
        width: 120.375rem;
        height: 2.625rem;

        .menu.transition.visible {
          min-width: 120.375rem;
        }
      }

      &.date-select {
        width: 100%;

        .menu.transition.visible {
          min-width: 100%;
        }

        .text {
          width: 92%;
        }
      }

      border: 1px solid #979797;
      border-radius: $pix-6;
      padding: 0.5625rem $pix-16;

      .text {
        width: 80%;
        font-size: $pix-14;
        line-height: $pix-18;
      }

      .menu.transition.visible {
        background: #ffffff;
        box-shadow: 0px $pix-6 $pix-12 rgba(0, 0, 0, 0.14);
        border-radius: $pix-8;
        margin-top: $pix-8;
        padding: $pix-16 0px;

        .item {
          margin-top: $pix-2;
          .title {
            font-size: $pix-16;
          }
        }
      }
    }
  }

  .dropdown-field {
    width: 9.5rem;

    .ui.dropdown {
      min-width: unset;
      width: 100%;
      margin-top: $pix-8;
      border: 1px solid #979797;
      margin-bottom: 0;
      height: $pix-40;
      min-height: unset;
      @extend %align-center;
      justify-content: space-between;
      max-width: 9.5rem;

      .text {
        font-size: $pix-14;
      }
    }
  }

  .form-input-wrapper {
    &:first-child {
      width: 20rem;
    }

    &:nth-child(2) {
      width: 10rem;
      // margin-left: $pix-25;
    }

    .field .ui.input {
      margin-bottom: 0;
      input {
        height: $pix-40;
        font-size: $pix-14;
        line-height: $pix-18;
        border-radius: $pix-6;
      }
    }

    .field.settlement-id-input,
    .field.vendor-id-input {
      .ui.input {
        max-width: 9.5rem;
      }
    }
    .error-message {
      top: $pix-4;
    }
  }

  .select-columns-list {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;

    .item {
      width: 33%;
      margin-bottom: $pix-4;
    }
  }

  .form-input-wrapper .ui.checkbox label {
    color: var(--SECONDARY_DARK);
  }

  .show-all-checkbox {
    margin-top: $pix-16;
  }

  .two-field-row .ui.input {
    margin-bottom: 0;
  }

  .date-range-select {
    &>div:last-child {
      width: 100%;
      height: $pix-40;
      margin-top: $pix-8;
      @extend %align-center;
      justify-content: space-between;

      button {
        border: 1px solid #979797;
        border-radius: $pix-6;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        &>span {
          max-width: fit-content;
        }
      }
    }
  }

  .form-checkbox {
    min-width: 33%;
    display: inline-block;
    margin-top: $pix-8 !important;

    input:checked~label:after {
      background: none;
    }
  }

  .checkbox-err {
    top: -0.75rem;
    right: 0;
  }

  .ui.fluid.dropdown.active {
    svg {
      transform: rotateX(180deg);
    }
  }

  .order-data-checkbox {
    margin: 0.6875rem auto 0 0 !important;
  }

  // .mt-1 {
  //   margin-top: 1rem !important;
  // }

  .ui.selection.dropdown.active {
    border: 1px solid var(--PRIMARY);
    svg {
      transform: rotateX(180deg);
    }
  }

}

.select-description {
  opacity: 0.7;
  font-size: $pix-10;
  margin-left: $pix-5;
}

.filters-select {
  .applied-filters {
    .filter {
      margin-left: 0;
      margin-right: $pix-12;
    }
  }
}

.min-width-0 {
  min-width: unset;
}

.report-filters-popup {
  .filter-list-item {
    max-width: 18.75rem;

    .filter-list {
      .item {
        width: 50%;
      }

      .dropdown-item {
        width: unset;

        .item {
          width: unset;
        }
      }
    }
  }
}

.report-type-dropdown {
  width: 20rem;
  
  .ui.selection.dropdown.modal-dropdown {
    @extend %align-center;
    justify-content: space-between;
    min-height: unset;
    height: $pix-40 !important;
    margin-bottom: 0;
    
    .text {
      font-size: $pix-14;
    }
    .visible.menu.transition {
      min-width: calc(100% + 1rem);

      .item {
        margin-right: $pix-8;
      }
      &::-webkit-scrollbar {
        display: block !important;
        width: 8px;

        &-track {
          border-radius: 100vw;
          margin-block: 0.8rem;
          margin-block-end: 2.8rem;
        }
        &-thumb {
          background: var--(SECONDARY_LIGHTER);
        }
      }
    }
  }
`;

export const UpfrontTDRFormTopSection = styled(Space)`
  background: #fff;
  border-radius: 0.5rem 0.5rem 0px 0px;
  border: 1px solid #e6e9ee;
`;

export const UpfrontTDRFormBottomSection = styled.div`
  border-radius: 0.5rem;
  border-radius: 0px 0px 0.5rem 0.5rem;
  border: 1px solid #e6e9ee;
  border-top: 0;
  background: #fff;
`;

export const StyledCheckbox = styled(Checkbox)`
  &&&.ui.checkbox {
    min-height: unset;
  }
`;

export const StyledToolTipDivider = styled.div`
  border: 1px solid var(--TABLE_COLUMN);
`;

export const DropdownCTAGroup = styled(Space)`
  border-top: 1px solid #e6e9ee;
  position: sticky;
  bottom: 0px;
  background: white;
  z-index: 999;
`;

export const StyledDropdown = styled(Dropdown)`
  &&&.ui.selection.dropdown {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0;
    min-height: unset;
    max-height: 2.375rem;
    max-width: 20rem;

    .default.text {
      font-size: 14px;
    }

    &.elements-selected {
      .default.text {
        color: #2b2d42;
      }
    }
  }
`;

// export const StyledRadioGroup = styled.div`
//   .inline.fields {
//     margin-top: 0;
//   }
//   .ui.radio.checkbox label {
//     margin-bottom: 8px;
//   }
// `;

export const StyledInputWithAction = styled.div`
  .ui.labeled.input {
    margin-bottom: 0;
    .label {
      border-bottom-left-radius: 0.375rem;
      border-top-left-radius: 0.375rem;
      width: 2.6875rem;
    }
    input {
      border-bottom-right-radius: 0.375rem;
      border-top-right-radius: 0.375rem;
    }
  }
`;

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 0.3fr 0.6fr 1fr;
`;

export const StyledButton = styled(Button)`
  max-width: 8.75rem;
`;

export const StyledSelectCheckbox = styled(Checkbox)`
  &&&.ui.fitted.checkbox {
    min-height: 1.0625rem;
  }
`;

export const StyledChipsWrapper = styled(Space)`
  max-width: 21.875rem;
`;

export const StyledChip = styled(Space)`
  padding: 0.25rem 0.5rem;
  border-radius: 2px;
  background: #e6e9ee;
`;

const borderStyles = css`
  border: ${props => props.highlight && '1px solid rgba(105, 48, 202, 0.25)'};
  border-radius: ${props => props.highlight && '8px'};
`;

export const HighlighterDiv = styled.div`
  ${borderStyles}
  -webkit-animation: target-fade 3s 1;
  -moz-animation: target-fade 3s 1;

  @-webkit-keyframes target-fade {
    0% {
      box-shadow: 0.375rem 0.375rem lightblue;
    }
    100% {
      box-shadow: unset;
    }
  }
  @-moz-keyframes target-fade {
    0% {
      box-shadow: 0.375rem 0.375rem lightblue;
    }
    100% {
      box-shadow: unset;
    }
  }
`;

export const StyledTableRow = styled(TableRow)`
  .ui.table tr&& {
    background-color: ${props =>
      props.highlightRow ? 'var(--SELECTED)' : 'white'};
  }
`;
